export default {
    deliveryTime: 'Odesíláme do 24 hodin',
    'category.empty.perex': 'Zanechte email, budeme vás informovat jakmile bude produkt připraven',
    'category.empty.title': 'Odebírat newsletter',

    'quantityDiscounts.ristre200g.12': '12 kusů',
    'quantityDiscounts.ristre200g.36': '36 kusů',

    'quantityDiscounts.ristre500g.6': '6 kusů',
    'quantityDiscounts.ristre500g.18': '18 kusů',

    priceWithoutVat: 'bez DPH',

    minOrderQuantity: 'Min. počet kusů v objednávce',
    forPurchase: 'Pro zakoupení <strong>1 ks</strong>',
    pieces: 'kusů',
    buyOn: 'nakoupit na',
}
